export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: "guide",
    name: "使用指南",
    description: "17c.cc 平台详细操作教程，从注册到高级功能全覆盖",
    icon: "ri-guide-line",
  },
  {
    slug: "feature",
    name: "功能介绍",
    description: "深入了解 17c.cc 各项核心功能的详细说明与使用场景",
    icon: "ri-stack-line",
  },
  {
    slug: "news",
    name: "最新动态",
    description: "17c.cc 平台更新公告、版本变化及最新上线功能资讯",
    icon: "ri-flashlight-line",
  },
  {
    slug: "faq",
    name: "常见问题",
    description: "汇总 17c.cc 用户最常遇到的问题及详细解决方案",
    icon: "ri-question-answer-line",
  },
  {
    slug: "security",
    name: "安全中心",
    description: "了解 17c.cc 账户安全设置、隐私保护及防诈骗知识",
    icon: "ri-shield-check-line",
  },
  {
    slug: "tips",
    name: "技巧分享",
    description: "17c.cc 使用小技巧、隐藏功能与高效操作经验分享",
    icon: "ri-lightbulb-line",
  },
];